import { createContext } from "react"
import type { ConfiguracaoFiscalAction } from "./configuracaoFiscalActions"
import { ConfiguracaoFiscalInicial } from "../models/configuracaoFiscalModel"
import type { ConfiguracaoFiscalModel } from "../models/configuracaoFiscalModel"

type ConfiguracaoFiscalContextProps = {
    dados: ConfiguracaoFiscalModel
    dispatch: React.Dispatch<ConfiguracaoFiscalAction>
    erroCarregamento: string | null
    salvar: () => Promise<void>
}

const initialContextValue: ConfiguracaoFiscalContextProps = {
    dados: ConfiguracaoFiscalInicial,
    dispatch: () => {},
    erroCarregamento: null,
    salvar: async () => {},
}

export const ConfiguracaoFiscalContext =
    createContext<ConfiguracaoFiscalContextProps>(initialContextValue)
